import React from "react";
import ViewListContainer from "./ViewListContainer";

const ViewListPage = () => {
    return (
        <section>
            <ViewListContainer/>
        </section>
    );
};

export default ViewListPage;
